/* eslint-disable react-hooks/exhaustive-deps */
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import {
    AttachMoney,
    EditLocation,
    Gite,
    MonetizationOn,
} from "@mui/icons-material";
import { ConfirmationReservationService } from "./services/ConfirmationReservationService";
import {
    reservationDefaultValue,
    transactionReqDefaultValue,
} from "../../utils/defaultNullValues";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import cover_compressed from "../../images/cover_compressed.jpg";
import { IServerConfig, serverConfig } from "../../utils/config";
import Chip from "@mui/material/Chip";
import moment from "moment";
import {
    ConvertedDeviseWithMoneySign,
    ConvertedDeviseWithoutMoneySign,
} from "../../utils/CurrencyConvertFunction";
import { CurrencyContext } from "../../contexts/AppContext";
import { useTranslation } from "react-i18next";
import { ITransactionReq } from "../../utils/PaymentInterfaces";
import { getDayNumber, getDayNumberProm } from "../../utils/App";
import { ETarifs, getStatusLabel, getTarifLabel } from "../../utils/enum";
import { useLocation } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { createStyles, makeStyles, TextField } from "@material-ui/core";
//import { History, Person, Update } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { UserContext } from "../../contexts/AppContext";
import { updateReservationState } from "../../Services/reservationServices";
//import { useHistory } from "react-router-dom";
import { LoginDialog } from "../components/Login/LoginDialog";
import { RegisterDialog } from "../components/Register/RegisterDialog";


const Env: IServerConfig = serverConfig;
const reservationService = new ConfirmationReservationService();
export const DetailReservation = () => {
    //const history = useHistory();
    const { i18n } = useTranslation<'common'>();
    const params: { id: string } = useParams();
    const location = useLocation();
    const currencyContext = useContext(CurrencyContext);
    const { currency } = currencyContext;
    const [reservation, setReservation] = useState<any>(
        reservationDefaultValue
    );
    const [loadingPage, setLoadingPage] = useState<boolean>(true);
    const [changeLogs, setChangeLogs] = useState<any[]>([]);
    const [
        ,
        // commission
        setCommission,
    ] = useState<number>(0);
    
    // All price variables
    // const [priceWithoutComs, setPriceWithoutComs] = useState<number>();
    // const [priceComs, setPriceComs] = useState<number>();
    // const [totalPrice, setTotalPrice] = useState<number>();
    const [transaction, setTransaction] = useState<ITransactionReq>(
        transactionReqDefaultValue
    );
    const [nbJourProm, setNbJourProm] = useState(0);
    const [nbJourSimple, setNbJourSimple] = useState(0);
    const [promotionRate, setPromotionRate] = useState(0);
    const [priceConverted, setPriceConverted] = useState<number>(0);
    const [priceConvertedProm, setPriceConvertedProm] = useState<number>(0);
    const [totalPriceProm, setTotalPriceProm] = useState<number>(0);
    const [totalPriceSimple, setTotalPriceSimple] = useState<number>(0);
    const [priceConvertedFinal, setPriceConvertedFinal] = useState<number>(0);
    const [specificHostPercentage, setSpecificHostPercentage] = useState<number>(0);
    const [cityHostPercentage, setCityHostPercentage] = useState<number>(0);
    const [ hostFee, setHostFee] = useState<number>(10);
    const [hostCommission, setHostCommission] = useState<number>(0);    
    const [ ,
        // priceBookingConverted
        setPriceBookingconverted,
    ] = useState<number>(0);
    const [priceServiceConverted, setPriceServiceconverted] =
        useState<number>(0);
    const [cleaningFees, setCleaningFees] = useState<number>(0);
    const [priceWithoutCleaningFees, setPriceWithoutCleaningFees] = useState(0);
    const [tarif, setTarif] = useState(ETarifs.JOURNALIER);
    const classes = style();
    const [openNoShowDialog, setOpenNoShowDialog] = useState(false);
    //const [isMarkingNoShow, setIsMarkingNoShow] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const userContext = useContext(UserContext);
    const { user } = userContext;
    const [noShowNotes, setNoShowNotes] = useState("");
    const [openLoginDialog, setOpenLoginDialog] = useState(false);
    const [openRegisterDialog, setOpenRegisterDialog] = useState(false);
    const [redirectPath, setRedirectPath] = useState("");

     useEffect(() => {
        if (!user._id) {
            setRedirectPath(window.location.pathname + window.location.search);
            setOpenLoginDialog(true);
        }
    }, [user._id]);

     const handleCloseLoginDialog = () => {
        setOpenLoginDialog(false);
    };

    const handleLoginSuccess = () => {
        setOpenLoginDialog(false);
        // Optionally refresh data after login
    };

    const handleClickOpenRegister = () => {
        setOpenLoginDialog(false);
        setOpenRegisterDialog(true);
    };

    useEffect(() => {
        reservationService
            .getTransactionDetailByReservationId(params.id)
            .then((response) => {
                let nbjours_prom: number;
                let nbjours_simple: number;
                let nbJour: number;
                if (response.success) {
                    let transaction = response.data;
                    const reservation = transaction.reservation;
                    const announce = transaction.reservation.announce;
                    const promotion = transaction.reservation.promotion;
    
                    setTransaction(response.data);
                    setReservation(reservation);
                    
                    if (promotion) {
                        nbjours_prom = getDayNumberProm(
                            moment(reservation.dateCheckIn).format("YYYY-MM-DD"),
                            moment(reservation.dateCheckOut).format("YYYY-MM-DD"),
                            moment(promotion.startDate).format("YYYY-MM-DD"),
                            moment(promotion.endDate).format("YYYY-MM-DD"),
                            announce.price,
                            promotion.price
                        ).DateProm;
                        nbjours_simple = getDayNumberProm(
                            moment(reservation.dateCheckIn).format("YYYY-MM-DD"),
                            moment(reservation.dateCheckOut).format("YYYY-MM-DD"),
                            moment(promotion.startDate).format("YYYY-MM-DD"),
                            moment(promotion.endDate).format("YYYY-MM-DD"),
                            announce.price,
                            promotion.price
                        ).DateSimple;
                        nbJour = nbjours_simple + nbjours_prom;
                        setNbJourSimple(nbjours_simple);
                        setNbJourProm(nbjours_prom);
                        setPromotionRate(promotion.discount);
                    }
    
                    if (response.data.reservation.announce?.property?.type.name === "Hotel") {
                        reservationService
                            .getSpecialFeeByPropertyType(
                                response.data.reservation.announce?.property?.type.name
                            )
                            .then((response) => {
                                if (response.success) {
                                    const percentage = response.data ? response.data.percentageTraveller : 0;
                                    const specificHostPercentage = response.data ? response.data.percentageTraveller : null;
                                    setCommission(percentage);
                                    setSpecificHostPercentage(specificHostPercentage);
                                    let priceProm;
                                    //let priceNorm;
                                    let totalPriceProm;
                                    let totalPriceNorm; 
                                    let priceNorm: number = Number(
                                        (reservation.announce.price + 
                                        reservation.announce.price * (percentage / 100))
                                        .toFixed(2)
                                    );
                                    if (promotion) {
                                        priceProm = (
                                            promotion.price +
                                            promotion.price * (percentage / 100)
                                        ).toFixed(2);
                                        
                                        // New consistent tariff selection logic
                                        let priceApplied = false;
                                        
                                        // Try monthly first (30+ days)
                                        if (nbJour >= 30 && reservation.announce.priceMonthly && reservation.announce.priceMonthly > 0) {
                                            priceNorm = Number(
                                                (reservation.announce.priceMonthly / 30 +
                                                (reservation.announce.priceMonthly / 30) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.MENSUEL);
                                            priceApplied = true;
                                        } 
                                        // If monthly not available, try biweekly (14-29 days)
                                        if (!priceApplied && nbJour >= 14 && reservation.announce.priceBiWeekly && reservation.announce.priceBiWeekly > 0) {
                                            priceNorm = Number(
                                                (reservation.announce.priceBiWeekly / 14 +
                                                (reservation.announce.priceBiWeekly / 14) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.QUINZAINE);
                                            priceApplied = true;
                                        } 
                                        // If biweekly not available, try weekly (7+ days)
                                        if (!priceApplied && nbJour >= 7 && reservation.announce.priceWeekly && reservation.announce.priceWeekly > 0) {
                                            priceNorm = Number(
                                                (reservation.announce.priceWeekly / 7 +
                                                (reservation.announce.priceWeekly / 7) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.HEBDOMADAIRE);
                                            priceApplied = true;
                                        }
                                        // Final fallback to daily price
                                        if (!priceApplied) {
                                            priceNorm = Number(
                                                (reservation.announce.price +
                                                reservation.announce.price * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.JOURNALIER);
                                        }
    
                                        totalPriceProm = priceProm * nbjours_prom;
                                        totalPriceNorm = priceNorm * nbjours_simple;
                                        const priceWithDaysWithCleanningAndCmomission =
                                            totalPriceNorm +
                                            totalPriceProm +
                                            (announce.cleaningFees +
                                                announce.cleaningFees *
                                                (percentage / 100));
                                        const totalService =
                                            transaction.reservation.services
                                                .length > 0
                                                ? transaction.reservation.services.reduce(
                                                    (prev: any, service: any) => prev + service.price,
                                                    0
                                                )
                                                : 0;
                                        const announceCleaningFees =
                                            announce.cleaningFees +
                                            announce.cleaningFees *
                                            (percentage / 100);
    
                                        // Rest of the conversion and state setting remains the same
                                        ConvertedDeviseWithMoneySign(
                                            announce.devise,
                                            currency,
                                            priceNorm
                                        )
                                            .then((value: any): any => {
                                                setPriceConverted(value);
                                            })
                                            .catch((error) => console.log(error));
                                            ConvertedDeviseWithMoneySign(
                                                announce.devise,
                                                currency,
                                                priceProm
                                            ).then((value: any): any => {
                                                setPriceConvertedProm(value);
                                            });
                                            ConvertedDeviseWithoutMoneySign(
                                                announce.devise,
                                                currency,
                                                Number(totalPriceProm.toFixed(2))
                                            ).then((pricePromFinal: any): any => {
                                                setTotalPriceProm(
                                                    Number(pricePromFinal)
                                                );
                                            });
                                            ConvertedDeviseWithoutMoneySign(
                                                announce.devise,
                                                currency,
                                                Number(totalPriceNorm.toFixed(2))
                                            ).then((priceNormFinal: any): any => {
                                                setTotalPriceSimple(
                                                    Number(priceNormFinal)
                                                );
                                                setPriceWithoutCleaningFees(
                                                    Number(priceNormFinal)
                                                );
                                            });
                                            ConvertedDeviseWithoutMoneySign(
                                                transaction.reservation.announce
                                                    .devise,
                                                currency,
                                                Number(
                                                    announceCleaningFees.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any =>
                                                    setCleaningFees(value)
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            if (totalService > 0) {
                                                ConvertedDeviseWithoutMoneySign(
                                                    "XAF",
                                                    currency,
                                                    Number(totalService.toFixed(2))
                                                )
                                                    .then(
                                                        (
                                                            totalServiceConverted: any
                                                        ): any => {
                                                            ConvertedDeviseWithoutMoneySign(
                                                                announce.devise,
                                                                currency,
                                                                Number(
                                                                    priceWithDaysWithCleanningAndCmomission.toFixed(
                                                                        2
                                                                    )
                                                                )
                                                            )
                                                                .then(
                                                                    (
                                                                        bookingPrice: any
                                                                    ): any => {
                                                                        // console.log("bookingPrice")
                                                                        setPriceBookingconverted(
                                                                            Number(
                                                                                bookingPrice
                                                                            )
                                                                        );
                                                                        setPriceServiceconverted(
                                                                            Number(
                                                                                totalServiceConverted
                                                                            )
                                                                        );
                                                                        setPriceConvertedFinal(
                                                                            Number(
                                                                                bookingPrice
                                                                            ) +
                                                                                Number(
                                                                                    totalServiceConverted
                                                                                )
                                                                        );
                                                                        setHostCommission(( Number(
                                                                                bookingPrice
                                                                            ) +
                                                                                Number(
                                                                                    totalServiceConverted
                                                                                ))* (hostFee / 100));
                                                                    }
                                                                )
                                                                .catch((error) =>
                                                                    console.log(
                                                                        error
                                                                    )
                                                                );
                                                        }
                                                    )
                                                    .catch((error) =>
                                                        console.log(error)
                                                    );
                                            } else {
                                                ConvertedDeviseWithoutMoneySign(
                                                    announce.devise,
                                                    currency,
                                                    Number(
                                                        priceWithDaysWithCleanningAndCmomission.toFixed(
                                                            2
                                                        )
                                                    )
                                                )
                                                    .then(
                                                        (
                                                            bookingPrice: any
                                                        ): any => {
                                                            // console.log("bookingPrice", bookingPrice)
                                                            setPriceBookingconverted(
                                                                Number(bookingPrice)
                                                            );
                                                            setPriceConvertedFinal(
                                                                Number(bookingPrice)
                                                            );
                                                            setHostCommission((Number(bookingPrice)) * (hostFee / 100));
                                                        }
                                                    )
                                                    .catch((error) =>
                                                        console.log(error)
                                                    );
                                            }
                                        } else {
                                        const jours = getDayNumber(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation.dateCheckOut
                                        );
                                        
                                        // New consistent tariff selection logic
                                        //let priceNormal;
                                        let priceNormal: number = Number(
                                        (reservation.announce.price + 
                                        reservation.announce.price * (percentage / 100))
                                        .toFixed(2)
                                    );
                                        let priceApplied = false;
    
                                        // Try monthly first (30+ days)
                                        if (jours >= 30 && reservation.announce.priceMonthly && reservation.announce.priceMonthly > 0) {
                                            priceNormal = Number(
                                                (reservation.announce.priceMonthly / 30 +
                                                (reservation.announce.priceMonthly / 30) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.MENSUEL);
                                            priceApplied = true;
                                        } 
                                        // If monthly not available, try biweekly (14-29 days)
                                        if (!priceApplied && jours >= 14 && reservation.announce.priceBiWeekly && reservation.announce.priceBiWeekly > 0) {
                                            priceNormal = Number(
                                                (reservation.announce.priceBiWeekly / 14 +
                                                (reservation.announce.priceBiWeekly / 14) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.QUINZAINE);
                                            priceApplied = true;
                                        } 
                                        // If biweekly not available, try weekly (7+ days)
                                        if (!priceApplied && jours >= 7 && reservation.announce.priceWeekly && reservation.announce.priceWeekly > 0) {
                                            priceNormal = Number(
                                                (reservation.announce.priceWeekly / 7 +
                                                (reservation.announce.priceWeekly / 7) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.HEBDOMADAIRE);
                                            priceApplied = true;
                                        }
                                        // Final fallback to daily price
                                        if (!priceApplied) {
                                            priceNormal = Number(
                                                (reservation.announce.price +
                                                reservation.announce.price * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.JOURNALIER);
                                        }
    
                                        // Rest of the existing conversion and state setting code
                                        const priceWithDays = priceNormal * jours;
                                        const priceWithDaysWithCleanningAndCmomission =
                                            priceWithDays +
                                            (transaction.reservation.announce.cleaningFees +
                                            transaction.reservation.announce.cleaningFees *
                                            (percentage / 100));
                                        
                                            const totalService =
                                            transaction.reservation.services
                                                .length > 0
                                                ? transaction.reservation.services.reduce(
                                                      (
                                                          prev: any,
                                                          service: any
                                                      ) => prev + service.price,
                                                      0
                                                  )
                                                : 0;
                                        const announceCleaningFees =
                                            announce.cleaningFees +
                                            announce.cleaningFees *
                                                (percentage / 100);

                                        ConvertedDeviseWithMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(priceNormal.toFixed(2))
                                        )
                                            .then((value: any): any =>
                                                setPriceConverted(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(
                                                announceCleaningFees.toFixed(2)
                                            )
                                        )
                                            .then((value: any): any =>
                                                setCleaningFees(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(priceWithDays.toFixed(2))
                                        )
                                            .then((value: any): any => {
                                                setPriceWithoutCleaningFees(
                                                    value
                                                );
                                            })
                                            .catch((error) =>
                                                console.log(error)
                                            );

                                        if (totalService > 0) {
                                            ConvertedDeviseWithoutMoneySign(
                                                "XAF",
                                                currency,
                                                Number(totalService.toFixed(2))
                                            )
                                                .then(
                                                    (
                                                        totalServiceConverted: any
                                                    ): any => {
                                                        ConvertedDeviseWithoutMoneySign(
                                                            transaction
                                                                .reservation
                                                                .announce
                                                                .devise,
                                                            currency,
                                                            Number(
                                                                priceWithDaysWithCleanningAndCmomission.toFixed(
                                                                    2
                                                                )
                                                            )
                                                        )
                                                            .then(
                                                                (
                                                                    bookingPrice: any
                                                                ): any => {
                                                                    setPriceBookingconverted(
                                                                        Number(
                                                                            bookingPrice
                                                                        )
                                                                    );
                                                                    setPriceServiceconverted(
                                                                        Number(
                                                                            totalServiceConverted
                                                                        )
                                                                    );
                                                                    setPriceConvertedFinal(
                                                                        Number(
                                                                            bookingPrice
                                                                        ) +
                                                                            Number(
                                                                                totalServiceConverted
                                                                            )
                                                                    );
                                                                    setHostCommission(( Number(
                                                                                bookingPrice
                                                                            ) +
                                                                                Number(
                                                                                    totalServiceConverted
                                                                                ))* (hostFee / 100));
                                                                    
                                                                }
                                                            )
                                                            .catch((error) =>
                                                                console.log(
                                                                    error
                                                                )
                                                            );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else {
                                            ConvertedDeviseWithoutMoneySign(
                                                transaction.reservation.announce
                                                    .devise,
                                                currency,
                                                Number(
                                                    priceWithDaysWithCleanningAndCmomission.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then(
                                                    (
                                                        bookingPrice: any
                                                    ): any => {
                                                        setPriceBookingconverted(
                                                            Number(bookingPrice)
                                                        );
                                                        setPriceConvertedFinal(
                                                            Number(bookingPrice)
                                                        );
                                                        setHostCommission((Number(bookingPrice)) * (hostFee / 100));
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        }
                                    }
                                }
                                    setLoadingPage(false);
                                
                            })
                            .catch((error) => {
                                setLoadingPage(false);
                                console.log(error);
                            });
                    } else {
                        const address = announce?.property?.address;
                        const countryId = address?.country?._id;
                        const cityId = address?.city?._id;
    
                        if (!countryId || !cityId) {
                            console.error("Missing country or city in property address:", {
                                countryId,
                                cityId,
                                address,
                            });
                            setLoadingPage(false);
                            return;
                        }
    
                        reservationService
                            .getHostFeeByCountryIdAndCityId(countryId, cityId)
                            .then((response) => {
                                //console.log("HostFeeByCountryIdAndCityId from DetailReservation")
                                if (response.success) {
                                    const cityHostPercentage = response.data ? response.data.percentage : null;
                                    setCityHostPercentage(cityHostPercentage);
                                }
                            })

                        reservationService
                            .getCommissionFeeByCountryIdAndCityId(countryId, cityId)
                            .then((response) => {
                                //console.log("CommissionFeeByCountryIdAndCityId from DetailReservation")
                                if (response.success) {
                                    const percentage = response.data ? response.data.percentage : 0;
                                    setCommission(percentage);
                                    let priceProm;
                                    //let priceNorm;
                                    let totalPriceProm;
                                    let totalPriceNorm;
                                    //let priceNormal;
                                    let priceNorm: number = Number(
                                    (reservation.announce.price + 
                                    reservation.announce.price * (percentage / 100))
                                    .toFixed(2))
                                    
                                    if (promotion) {
                                        priceProm = (
                                            promotion.price +
                                            promotion.price * (percentage / 100)
                                        ).toFixed(2);
                                        
                                        // New consistent tariff selection logic
                                        let priceApplied = false;
                                        
                                        // Try monthly first (30+ days)
                                        if (nbJour >= 30 && reservation.announce.priceMonthly && reservation.announce.priceMonthly > 0) {
                                            priceNorm = Number(
                                                (reservation.announce.priceMonthly / 30 +
                                                (reservation.announce.priceMonthly / 30) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.MENSUEL);
                                            priceApplied = true;
                                        } 
                                        // If monthly not available, try biweekly (14-29 days)
                                        if (!priceApplied && nbJour >= 14 && reservation.announce.priceBiWeekly && reservation.announce.priceBiWeekly > 0) {
                                            priceNorm = Number(
                                                (reservation.announce.priceBiWeekly / 14 +
                                                (reservation.announce.priceBiWeekly / 14) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.QUINZAINE);
                                            priceApplied = true;
                                        } 
                                        // If biweekly not available, try weekly (7+ days)
                                        if (!priceApplied && nbJour >= 7 && reservation.announce.priceWeekly && reservation.announce.priceWeekly > 0) {
                                            priceNorm = Number(
                                                (reservation.announce.priceWeekly / 7 +
                                                (reservation.announce.priceWeekly / 7) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.HEBDOMADAIRE);
                                            priceApplied = true;
                                        }
                                        // Final fallback to daily price
                                        if (!priceApplied) {
                                            priceNorm = Number(
                                                (reservation.announce.price +
                                                reservation.announce.price * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.JOURNALIER);
                                        }
                                        totalPriceProm =
                                            priceProm * nbjours_prom;
                                        totalPriceNorm =
                                            priceNorm * nbjours_simple;
                                        const priceWithDaysWithCleanningAndCmomission =
                                            totalPriceNorm +
                                            totalPriceProm +
                                            (announce.cleaningFees +
                                                announce.cleaningFees *
                                                    (percentage / 100));
                                        const totalService =
                                            transaction.reservation.services
                                                .length > 0
                                                ? transaction.reservation.services.reduce(
                                                      (
                                                          prev: any,
                                                          service: any
                                                      ) => prev + service.price,
                                                      0
                                                  )
                                                : 0;
                                        const announceCleaningFees =
                                            announce.cleaningFees +
                                            announce.cleaningFees *
                                                (percentage / 100);
                                                
                                        ConvertedDeviseWithMoneySign(
                                            announce.devise,
                                            currency,
                                            priceNorm
                                        )
                                            .then((value: any): any => {
                                                //console.log('Currency conversion result priceNorm:', value);
                                                setPriceConverted(value);
                                                // console.log("value", value)
                                            })
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithMoneySign(
                                            announce.devise,
                                            currency,
                                            priceProm
                                        ).then((value: any): any => {
                                            //console.log('Currency conversion result priceProm:', value);
                                            setPriceConvertedProm(value);
                                        });
                                        ConvertedDeviseWithoutMoneySign(
                                            announce.devise,
                                            currency,
                                            Number(totalPriceProm.toFixed(2))
                                        ).then((pricePromFinal: any): any => {
                                            //console.log('Currency conversion result totalPriceProm:', pricePromFinal);
                                            setTotalPriceProm(
                                                Number(pricePromFinal)
                                            );
                                        });
                                        ConvertedDeviseWithoutMoneySign(
                                            announce.devise,
                                            currency,
                                            Number(totalPriceNorm.toFixed(2))
                                        ).then((priceNormFinal: any): any => {
                                            //console.log('Currency conversion result priceNormFinal:', priceNormFinal);
                                            setTotalPriceSimple(
                                                Number(priceNormFinal)
                                            );
                                            setPriceWithoutCleaningFees(
                                                Number(priceNormFinal)
                                            );
                                        });
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(
                                                announceCleaningFees.toFixed(2)
                                            )
                                        )
                                            .then((value: any): any =>
                                                setCleaningFees(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        if (totalService > 0) {
                                            ConvertedDeviseWithoutMoneySign(
                                                "XAF",
                                                currency,
                                                Number(totalService.toFixed(2))
                                            )
                                                .then(
                                                    (
                                                        totalServiceConverted: any
                                                    ): any => {
                                                        ConvertedDeviseWithoutMoneySign(
                                                            announce.devise,
                                                            currency,
                                                            Number(
                                                                priceWithDaysWithCleanningAndCmomission.toFixed(
                                                                    2
                                                                )
                                                            )
                                                        )
                                                            .then(
                                                                (
                                                                    bookingPrice: any
                                                                ): any => {
                                                                    // console.log("bookingPrice")
                                                                    setPriceBookingconverted(
                                                                        Number(
                                                                            bookingPrice
                                                                        )
                                                                    );
                                                                    setPriceServiceconverted(
                                                                        Number(
                                                                            totalServiceConverted
                                                                        )
                                                                    );
                                                                    setPriceConvertedFinal(
                                                                        Number(
                                                                            bookingPrice
                                                                        ) +
                                                                            Number(
                                                                                totalServiceConverted
                                                                            )
                                                                    );
                                                                    setHostCommission(( Number(
                                                                                bookingPrice
                                                                            ) +
                                                                                Number(
                                                                                    totalServiceConverted
                                                                                ))* (hostFee / 100));
                                                                }
                                                            )
                                                            .catch((error) =>
                                                                console.log(
                                                                    error
                                                                )
                                                            );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else {
                                            ConvertedDeviseWithoutMoneySign(
                                                announce.devise,
                                                currency,
                                                Number(
                                                    priceWithDaysWithCleanningAndCmomission.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then(
                                                    (
                                                        bookingPrice: any
                                                    ): any => {
                                                        // console.log("bookingPrice", bookingPrice)
                                                        setPriceBookingconverted(
                                                            Number(bookingPrice)
                                                        );
                                                        setPriceConvertedFinal(
                                                            Number(bookingPrice)
                                                        );
                                                        setHostCommission((Number(bookingPrice)) * (hostFee / 100));
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        }
                                    } else {
                                        const jours = getDayNumber(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation.dateCheckOut
                                        );
                                        
                                        // New consistent tariff selection logic
                                        //let priceNormal;
                                        let priceNormal: number = Number(
                                        (reservation.announce.price + 
                                        reservation.announce.price * (percentage / 100))
                                        .toFixed(2))
                                        let priceApplied = false;
    
                                        // Try monthly first (30+ days)
                                        if (jours >= 30 && reservation.announce.priceMonthly && reservation.announce.priceMonthly > 0) {
                                            priceNormal = Number(
                                                (reservation.announce.priceMonthly / 30 +
                                                (reservation.announce.priceMonthly / 30) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.MENSUEL);
                                            priceApplied = true;
                                        } 
                                        // If monthly not available, try biweekly (14-29 days)
                                        if (!priceApplied && jours >= 14 && reservation.announce.priceBiWeekly && reservation.announce.priceBiWeekly > 0) {
                                            priceNormal = Number(
                                                (reservation.announce.priceBiWeekly / 14 +
                                                (reservation.announce.priceBiWeekly / 14) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.QUINZAINE);
                                            priceApplied = true;
                                        } 
                                        // If biweekly not available, try weekly (7+ days)
                                        if (!priceApplied && jours >= 7 && reservation.announce.priceWeekly && reservation.announce.priceWeekly > 0) {
                                            priceNormal = Number(
                                                (reservation.announce.priceWeekly / 7 +
                                                (reservation.announce.priceWeekly / 7) * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.HEBDOMADAIRE);
                                            priceApplied = true;
                                        }
                                        // Final fallback to daily price
                                        if (!priceApplied) {
                                            priceNormal = Number(
                                                (reservation.announce.price +
                                                reservation.announce.price * (percentage / 100))
                                                .toFixed(2)
                                            );
                                            setTarif(ETarifs.JOURNALIER);
                                        }
                                        const priceWithDays =
                                        priceNormal * jours;
                                    const priceWithDaysWithCleanningAndCmomission =
                                        priceWithDays +
                                        (transaction.reservation.announce
                                            .cleaningFees +
                                            transaction.reservation.announce
                                                .cleaningFees *
                                                (percentage / 100));
                                    const totalService =
                                        transaction.reservation.services
                                            .length > 0
                                            ? transaction.reservation.services.reduce(
                                                  (
                                                      prev: any,
                                                      service: any
                                                  ) => prev + service.price,
                                                  0
                                              )
                                            : 0;
                                    const announceCleaningFees =
                                        announce.cleaningFees +
                                        announce.cleaningFees *
                                            (percentage / 100);

                                    ConvertedDeviseWithMoneySign(
                                        transaction.reservation.announce
                                            .devise,
                                        currency,
                                        Number(priceNormal.toFixed(2))
                                    )
                                        .then((value: any): any =>
                                            setPriceConverted(value)
                                        )
                                        .catch((error) =>
                                            console.log(error)
                                        );
                                    ConvertedDeviseWithoutMoneySign(
                                        transaction.reservation.announce
                                            .devise,
                                        currency,
                                        Number(
                                            announceCleaningFees.toFixed(2)
                                        )
                                    )
                                        .then((value: any): any =>
                                            setCleaningFees(value)
                                        )
                                        .catch((error) =>
                                            console.log(error)
                                        );
                                    ConvertedDeviseWithoutMoneySign(
                                        transaction.reservation.announce
                                            .devise,
                                        currency,
                                        Number(priceWithDays.toFixed(2))
                                    )
                                        .then((value: any): any => {
                                            setPriceWithoutCleaningFees(
                                                value
                                            );
                                        })
                                        .catch((error) =>
                                            console.log(error)
                                        );

                                    if (totalService > 0) {
                                        ConvertedDeviseWithoutMoneySign(
                                            "XAF",
                                            currency,
                                            Number(totalService.toFixed(2))
                                        )
                                            .then(
                                                (
                                                    totalServiceConverted: any
                                                ): any => {
                                                    ConvertedDeviseWithoutMoneySign(
                                                        transaction
                                                            .reservation
                                                            .announce
                                                            .devise,
                                                        currency,
                                                        Number(
                                                            priceWithDaysWithCleanningAndCmomission.toFixed(
                                                                2
                                                            )
                                                        )
                                                    )
                                                        .then(
                                                            (
                                                                bookingPrice: any
                                                            ): any => {
                                                                setPriceBookingconverted(
                                                                    Number(
                                                                        bookingPrice
                                                                    )
                                                                );
                                                                setPriceServiceconverted(
                                                                    Number(
                                                                        totalServiceConverted
                                                                    )
                                                                );
                                                                setPriceConvertedFinal(
                                                                    Number(
                                                                        bookingPrice
                                                                    ) +
                                                                        Number(
                                                                            totalServiceConverted
                                                                        )
                                                                );
                                                                setHostCommission(( Number(
                                                                                bookingPrice
                                                                            ) +
                                                                                Number(
                                                                                    totalServiceConverted
                                                                                ))* (hostFee / 100));
                                                            }
                                                        )
                                                        .catch((error) =>
                                                            console.log(
                                                                error
                                                            )
                                                        );
                                                }
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                    } else {
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(
                                                priceWithDaysWithCleanningAndCmomission.toFixed(
                                                    2
                                                )
                                            )
                                        )
                                            .then(
                                                (
                                                    bookingPrice: any
                                                ): any => {
                                                    setPriceBookingconverted(
                                                        Number(bookingPrice)
                                                    );
                                                    setPriceConvertedFinal(
                                                        Number(bookingPrice)
                                                    );
                                                    setHostCommission((Number(bookingPrice)) * (hostFee / 100));
                                                }
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                    }
                                }
                            }
                                setLoadingPage(false);
                            })
                            .catch((error) => {
                                setLoadingPage(false);
                                console.log(error);
                            });

                        }
                }
            })
            .catch((error) => {
                setLoadingPage(false);
                console.log(error);
            });
    }, [params.id, currency]);

    
    useEffect(() => {
        if (reservation?._id) {
            reservationService.getReservationChangeLogs(reservation._id)
                .then((response) => {
                    if (response.success) {
                        setChangeLogs(response.data);
                    }
                })
                .catch((error) => console.log(error));
        }
    }, [reservation]);


    useEffect(() => {
    const hostFees = specificHostPercentage ?? cityHostPercentage ?? 0;
    setHostFee(hostFees);
    }, [specificHostPercentage, cityHostPercentage]);

    const treatAsUTC = (date: any): any => {
        var result = new Date(date);
        result.setMinutes(result.getMinutes() - result.getTimezoneOffset());

        return result;
    };

    const handleOpenNoShowDialog = () => {
    setOpenNoShowDialog(true);
};

const handleCloseNoShowDialog = () => {
    setOpenNoShowDialog(false);
};

const handleMarkNoShow = async () => {
    try {
        const response = await updateReservationState(reservation._id, {
            status: "no_show",
            changedBy: {
                userId: user._id,
                firstName: user.firstName,
                lastName: user.lastName
            },
            notes: noShowNotes,
            timestamp: new Date().toISOString()
        });

        if (response?.success) {
            // Update local state to reflect changes
            const updatedStatus = [
                ...reservation.status,
                {
                    status: "no_show",
                    changedBy: {
                        userId: user._id,
                        firstName: user.firstName,
                        lastName: user.lastName
                    },
                    notes: noShowNotes,
                    timestamp: new Date().toISOString()
                }
            ];
            
            setReservation({
                ...reservation,
                status: updatedStatus,
                currentState: "no_show"
            });
            
            enqueueSnackbar("Successfully marked as no-show", { variant: "success" });
        } else {
            enqueueSnackbar("Failed to update status", { variant: "error" });
        }
    } catch (error) {
        enqueueSnackbar("An error occurred", { variant: "error" });
        console.error("Error marking no-show:", error);
    }
};

    // Return the numbers of days between 2 days
    const daysBetween = (startDate: any, endDate: any) => {
        var millisecondsPerDay = 24 * 60 * 60 * 1000;
        return (
            (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay
        );
    };

    const { t } = useTranslation<'common'>();

    function formatCurrency(amount: number, currency: any): string {
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          minimumFractionDigits: currency === 'EUR' ? 2 : 0,
          maximumFractionDigits: currency === 'EUR' ? 2 : 0
        });
        return formatter.format(amount);
      }


    return (
        <>
            
            {!user._id ? (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '50vh' 
            }}>
                <Typography variant="h6">
                    Please log in to view reservation details
                </Typography>
            </div>
        
            ) : loadingPage ? (
                <div className={classes.loading}>
                    <PropagateLoader color="#36D7B7" size={15} />
                </div>
            ) : (
                <Stack>
                    <Stack
                        sx={{
                            margin: "30px 0",
                            padding: 5,
                            backgroundColor: "white",
                        }}
                    >
                        <Stack marginTop={2}>
                            <Typography
                                marginBottom={2}
                                fontFamily={"Josefin Sans"}
                                fontSize={20}
                                fontWeight={400}
                                
                            >
                                {t("recu.labels.id-reservation")}{" "}
                                <span style={{ fontWeight: 400, color: '#890608'  }}>
                                    {`${transaction?.reservation?._id?.slice(0, 6).toUpperCase()}${transaction?.reservation?._id?.slice(6)}`}
                                </span>
                            </Typography>
                            <Typography
                                marginBottom={2}
                                fontFamily={"Josefin Sans"}
                                fontSize={20}
                                fontWeight={400}
                            >
                                {t("listTable.status")}{" "}
                                <span style={{ 
                                    fontWeight: 600, 
                                    color: getStatusLabel(reservation.status[reservation.status.length - 1]?.status) === t("reservation.status.no-show") 
                                        ? '#d32f2f' 
                                        : '#890608'
                                }}>
                                    {getStatusLabel(reservation.status[reservation.status.length - 1]?.status)}
                                </span>
                                
                                {/* Show who changed the status and when for no-show */}
                                {getStatusLabel(reservation.status[reservation.status.length - 1]?.status) === t("reservation.status.no-show") && (
                                    <Typography
                                        fontSize={14}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        color="textSecondary"
                                        mt={1}
                                    >
                                        {t("no_show.marked_by")}: {reservation.status[reservation.status.length - 1]?.changedBy?.firstName} {reservation.status[reservation.status.length - 1]?.changedBy?.lastName}
                                        <br />
                                        {t("no_show.on_date")}: {moment(reservation.status[reservation.status.length - 1]?.timestamp).format("DD/MM/YYYY HH:mm")}
                                        {reservation.status[reservation.status.length - 1]?.notes && (
                                            <>
                                                <br />
                                                {t("no_show.notes")}: {reservation.status[reservation.status.length - 1]?.notes}
                                            </>
                                        )}
                                    </Typography>
                                )}

                                {/* No Show button - only show if not already no-show and after check-in time */}
                                {getStatusLabel(reservation.status[reservation.status.length - 1]?.status) !== t("reservation.status.no-show") && 
                                    moment().isAfter(reservation.dateCheckIn) && (
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        onClick={handleOpenNoShowDialog}
                                        style={{ 
                                            marginLeft: '16px',
                                            textTransform: 'none',
                                            fontWeight: 500
                                        }}
                                    >
                                        {t("no_show.mark_button")}
                                    </Button>
                                )}
                            </Typography>
                        </Stack>
                        <Divider sx={{ marginBottom: 8 }} />
                        <Stack marginBottom={8}>
                            <Typography
                                fontFamily={"Josefin Sans"}
                                fontSize={20}
                                fontWeight={400}
                            >
                                {t("reservation.label.date-de-reservation")} :{" "}
                                {moment(reservation.createdAt).format(
                                    "DD/MM/YYYY hh:mm a"
                                )}
                            </Typography>{reservation.bookingContext?.bookedByAdmin === true && (
                                <Typography
                                    fontFamily={"Josefin Sans"}
                                    fontSize={16}
                                    fontWeight={400}
                                >
                                    {t("reservation.label.par")}{" "}
                                    {reservation.bookingContext?.adminFirstName ?? ""}{" "}
                                    {reservation.bookingContext?.adminLastName ?? ""}
                                </Typography>
                            )}
                            <Typography
                                fontFamily={"Josefin Sans"}
                                fontSize={16}
                                fontWeight={400}
                            >
                                {t("reservation.label.for")}{" "}
                                {reservation.traveller.firstName ?? ""}{" "}
                                {reservation.traveller.lastName ?? ""}
                            </Typography>
                            {location.pathname.startsWith(
                                "/admin/booking-details"
                            ) && (
                                <>
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {reservation.traveller.email ?? ""}
                                    </Typography>
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {reservation.traveller.phone ?? ""}
                                    </Typography>
                                </>
                            )}
                        </Stack>
                        <Stack>
                            <Grid container item direction={"row"}>
                                <Grid
                                    item
                                    xs={12}
                                    md={3}
                                    lg={3}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                >
                                    <img
                                        src={
                                            reservation.announce.property
                                                .photos[0]?.filename
                                                ? `${Env.ApiRoot}/images/properties/${reservation.announce.property.photos[0].filename}`
                                                : cover_compressed
                                        }
                                        alt=""
                                        style={{
                                            width: 150,
                                            height: 200,
                                            objectFit: "cover",
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={8} lg={8}>
                                    <Stack
                                        direction={"row"}
                                        justifyContent={"space-between"}
                                    >
                                        <Typography
                                            fontSize={24}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={400}
                                        >
                                            {reservation.announce.property.name}
                                        </Typography>
                                        {/*<Typography
                                            fontSize={24}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={400}
                                        >
                                            {priceConverted}
                                        </Typography> */}
                                    </Stack>
                                    <Divider
                                        sx={{ marginTop: 3, marginBottom: 3 }}
                                    />
                                    <Stack
                                        direction={"row"}
                                        marginBottom={1}
                                        justifyContent={"space-between"}
                                    >
                                        <Stack>
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={400}
                                            >
                                                {t("searchBar.checkIn")}:{" "}
                                                {moment(
                                                    reservation.dateCheckIn
                                                ).format("DD/MM/YYYY")}
                                            </Typography>
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={400}
                                            >
                                                {t("searchBar.checkOut")}:{" "}
                                                {moment(
                                                    reservation.dateCheckOut
                                                ).format("DD/MM/YYYY")}
                                            </Typography>
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={400}
                                            >
                                                {daysBetween(
                                                    reservation.dateCheckIn,
                                                    reservation.dateCheckOut
                                                )}{" "}
                                                {t("label.jours")}
                                            </Typography>
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={400}
                                            >
                                                {reservation.travellerAdultTotal +
                                                    reservation.travellerChildTotal}{" "}
                                                {t("label.voyageurs")}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Stack>
                        {/*// Host Details*/}

                        {location.pathname.startsWith(
                                "/admin/booking-details"
                            ) && (
                        <>
                            <Divider sx={{ marginTop: 6, marginBottom: 3 }} />
                            <Grid container direction={"row"}>
                                <Grid item xs={12} md={3} lg={3}>
                                    <Typography
                                        fontSize={20}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={400}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Gite
                                            style={{
                                                marginRight: "10px",
                                                color: "#880608",
                                            }}
                                        />{" "}
                                        {t("reservation.label.detail-de-l-hote")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={5} lg={5}>
                                    <Typography
                                        fontSize={18}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={400}
                                    >
                                        {t(
                                            "reservation.label.information-personnelle"
                                        )}
                                    </Typography>
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {reservation.host.firstName ?? ""}{" "}
                                        {reservation.host.lastName ?? ""}
                                    </Typography>
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {reservation.host.gender}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} lg={4}>
                                    <Typography
                                        fontSize={18}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={400}
                                    >
                                        {t(
                                            "reservation.label.information-de-contact"
                                        )}
                                    </Typography>
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {reservation.host.email ?? ""}
                                    </Typography>
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {reservation.host.phone ?? ""}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={4} lg={4}>
                                <Typography
                                    fontSize={18}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={400}
                                >
                                    {t("reservation.label.comment-acceder")}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    {reservation.announce.contactName}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    {reservation.announce.contactPhone}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    {reservation.announce.sponsorshipCode}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    {reservation.announce.howToAccessDesc}
                                </Typography>
                                {reservation.announce.property.equipments &&
                                    reservation.announce.property.equipments.map(
                                        (item: any, index: number) => (
                                            <Chip
                                                key={index}
                                                label={item.name[i18n.language === "fr" ? "fr" : "en"]}
                                                color="primary"
                                                style={{ margin: 1 }}
                                            />
                                        )
                                    )}
                            </Grid>
                            </Grid> 
                        </>)}

                        {/*// Property Details*/}
                        <Divider sx={{ marginTop: 6, marginBottom: 3 }} />
                        <Grid container direction={"row"}>
                            <Grid item xs={12} md={3} lg={3}>
                                <Typography
                                    fontSize={20}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={400}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <EditLocation
                                        style={{
                                            marginRight: "10px",
                                            color: "#880608",
                                        }}
                                    />{" "}
                                    {t(
                                        "reservation.label.detail-de-la-propriete"
                                    )}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={5} lg={5}>
                                <Typography
                                    fontSize={18}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={400}
                                >
                                    {t("reservation.label.adresse")}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    {i18n.language === "fr"
                                    ? reservation.announce.property.address.country?.nomFR
                                    : reservation.announce.property.address.country?.nomEN}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    
                                    {i18n.language === "fr"
                                    ? reservation.announce.property.address.city?.nomFR
                                    : reservation.announce.property.address.city?.nomEN}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    {
                                        reservation.announce.property.address?.quartier
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                                <Typography
                                    fontSize={18}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={400}
                                >
                                    {t("reservation.label.a-propos")}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    {reservation.announce.property.type.label
                                        ? t(
                                              reservation.announce.property.type
                                                  .label
                                          )
                                        : reservation.announce.property.type
                                              .name}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    {reservation.announce.property.rooms}{" "}
                                    {t("reservation.label.chambres")}
                                </Typography>
                                {reservation.announce.property.equipments &&
                                    reservation.announce.property.equipments.map(
                                        (item: any, index: number) => (
                                            <Chip
                                                key={index}
                                                label={item.name[i18n.language === "fr" ? "fr" : "en"]}
                                                color="primary"
                                                style={{ margin: 1 }}
                                            />
                                        )
                                    )}
                            </Grid>                            
                        </Grid>
                        {/*// Payments Details*/}
                        <Divider sx={{ marginTop: 6, marginBottom: 3 }} />
                        <Grid container direction={"row"}>
                            <Grid item xs={12} md={3} lg={3}>
                                <Typography
                                    fontSize={20}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={400}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <MonetizationOn
                                        style={{
                                            marginRight: "10px",
                                            color: "#880608",
                                        }}
                                    />{" "}
                                    {t("reservation.label.detail-du-paiement")}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={5} lg={5}>
                                {/* Payment Method */}
                                <Typography
                                    fontSize={18}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={400}
                                >
                                    {reservation.isAdvancePayment 
                                        ? t("reservation.label.payment-method")
                                        : t("reservation.label.payer-integralement-avec")}
                                </Typography>
                                <Typography
                                    fontSize={16}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={300}
                                    variant={"body2"}
                                >
                                    {transaction.method}
                                </Typography>

                                {/* Payment Breakdown */}
                                {(reservation.isAdvancePayment || transaction.method === 'BNPL') && (
                                    <>
                                        <Typography
                                            fontSize={18}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={400}
                                            mt={2}
                                        >
                                            {t("reservation.label.payment-breakdown")}:
                                        </Typography>
                                        
                                        <Typography
                                            fontSize={16}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={300}
                                            variant={"body2"}
                                        >
                                            • {t("reservation.label.advance-payment")}: {formatCurrency(reservation.advancePaymentAmount, currency)}
                                            {reservation.advancePaymentPercentage > 0 && (
                                                <span> ({reservation.advancePaymentPercentage}%)</span>
                                            )}
                                        </Typography>
                                        
                                        <Typography
                                            fontSize={16}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={300}
                                            variant={"body2"}
                                        >
                                            • {t("reservation.label.remaining-amount")}: {formatCurrency(reservation.remainingAmount, currency)}
                                        </Typography>
                                        
                                        <Typography
                                            fontSize={16}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={300}
                                            variant={"body2"}
                                        >
                                            • {t("reservation.label.payment-due-date")}: {moment(reservation.dateCheckIn).format("DD/MM/YYYY")}
                                        </Typography>
                                    </>
                                )}

                                {/* Services */}
                                {reservation.services.length > 0 && (
                                    <>
                                        <Typography
                                            fontSize={18}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={400}
                                            mt={2}
                                        >
                                            {t("label.frais-de-service")}:
                                        </Typography>
                                        {reservation.services.map((service: any) => (
                                            <div key={service._id}>
                                                <Typography
                                                    fontSize={16}
                                                    fontFamily={"Josefin Sans"}
                                                    fontWeight={400}
                                                    variant={"body2"}
                                                >
                                                    {service.name}:
                                                </Typography>
                                                <Typography
                                                    fontSize={16}
                                                    fontFamily={"Josefin Sans"}
                                                    fontWeight={300}
                                                    variant={"body2"}
                                                >
                                                    {service.description}
                                                </Typography>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </Grid>
                        </Grid>
                        {/*// Total*/}
                        <Divider sx={{ marginTop: 6, marginBottom: 3 }} />
                        <Grid container direction={"row"}>
                            <Grid item xs={12} md={3} lg={3}>
                                <Typography
                                    fontSize={20}
                                    fontFamily={"Josefin Sans"}
                                    fontWeight={400}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <AttachMoney
                                        style={{
                                            marginRight: "10px",
                                            color: "#880608",
                                        }}
                                    />{" "}
                                    {t("reservation.label.prix-de-la-location")}{" "}
                                    :
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                lg={9}
                                marginTop={5}
                                marginBottom={15}
                            >
                                {nbJourProm > 0 ? (
                                    <>
                                        {nbJourSimple > 0 && (
                                            <>
                                                <Stack
                                                    direction={"row"}
                                                    justifyContent={
                                                        "space-between"
                                                    }
                                                >
                                                    <Typography
                                                        fontSize={16}
                                                        fontFamily={
                                                            "Josefin Sans"
                                                        }
                                                        fontWeight={300}
                                                        variant={"body2"}
                                                    >
                                                        {t(
                                                            "label.tarif-applique"
                                                        )}{" "}
                                                        :{" "}
                                                    </Typography>
                                                    <Typography
                                                        fontSize={16}
                                                        fontFamily={
                                                            "Josefin Sans"
                                                        }
                                                        fontWeight={300}
                                                        variant={"body2"}
                                                    >
                                                        {getTarifLabel(tarif)}
                                                    </Typography>
                                                </Stack>
                                                <Stack
                                                    direction={"row"}
                                                    justifyContent={
                                                        "space-between"
                                                    }
                                                >
                                                    <Typography
                                                        fontSize={16}
                                                        fontFamily={
                                                            "Josefin Sans"
                                                        }
                                                        fontWeight={300}
                                                        variant={"body2"}
                                                    >
                                                        {priceConverted} x{" "}
                                                        {nbJourSimple}{" "}
                                                        {t(
                                                            "recu.labels.nuitees"
                                                        )}{" "}
                                                        :{" "}
                                                    </Typography>
                                                    <Typography
                                                        fontSize={16}
                                                        fontFamily={
                                                            "Josefin Sans"
                                                        }
                                                        fontWeight={300}
                                                        variant={"body2"}
                                                    >
                                                        {/*{totalPriceSimple}{" "}
                                                        {currency.toUpperCase()}*/}
                                                        {formatCurrency(totalPriceSimple, currency)}
                                                    </Typography>
                                                </Stack>
                                            </>
                                        )}
                                        <Stack
                                            direction={"row"}
                                            justifyContent={"space-between"}
                                        >
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={300}
                                                variant={"body2"}
                                            >
                                                {priceConvertedProm} x{" "}
                                                {nbJourProm}{" "}
                                                {t("recu.labels.nuitees")}{" "}
                                                {`(-${promotionRate}%)`}:
                                            </Typography>
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={300}
                                                variant={"body2"}
                                            >
                                                {/*{totalPriceProm}{" "}
                                                {currency.toUpperCase()}*/}
                                                {formatCurrency(totalPriceProm, currency)}
                                            </Typography>
                                        </Stack>
                                    </>
                                ) : (
                                    <>
                                        <Stack
                                            direction={"row"}
                                            justifyContent={"space-between"}
                                        >
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={300}
                                                variant={"body2"}
                                            >
                                                {t("label.tarif-applique")} :{" "}
                                            </Typography>
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={300}
                                                variant={"body2"}
                                            >
                                                {getTarifLabel(tarif)}
                                            </Typography>
                                        </Stack>
                                        <Stack
                                            direction={"row"}
                                            justifyContent={"space-between"}
                                        >
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={300}
                                                variant={"body2"}
                                            >
                                                {t("listTable.labels.quantity")} :{" "}
                                            </Typography>
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={300}
                                                variant={"body2"}
                                            >
                                                {reservation?.roomsBooked}
                                            </Typography>
                                        </Stack>
                                        <Stack
                                            direction={"row"}
                                            justifyContent={"space-between"}
                                        >
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={300}
                                                variant={"body2"}
                                            >
                                                {priceConverted} x{" "}
                                                {daysBetween(
                                                    reservation.dateCheckIn,
                                                    reservation.dateCheckOut
                                                )}{" "}
                                                {t("recu.labels.nuitees")} :{" "}
                                            </Typography>
                                            <Typography
                                                fontSize={16}
                                                fontFamily={"Josefin Sans"}
                                                fontWeight={300}
                                                variant={"body2"}
                                            >
                                                {/*{priceWithoutCleaningFees}{" "}
                                                {currency.toUpperCase()}*/}
                                                {formatCurrency(priceWithoutCleaningFees, currency)}
                                            </Typography>
                                        </Stack>
                                    </>
                                )}
                                <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                >
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {t("label.frais-de-nettoyage")} :{" "}
                                    </Typography>
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {/*{cleaningFees} {currency.toUpperCase()}*/}                                        
                                        {formatCurrency(cleaningFees, currency)}
                                    </Typography>
                                </Stack>
                                <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                >
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {t("label.frais-de-service")} :{" "}
                                    </Typography>
                                    <Typography
                                        fontSize={16}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={300}
                                        variant={"body2"}
                                    >
                                        {/*{priceServiceConverted}{" "}
                                        {currency.toUpperCase()} */}
                                        {formatCurrency(priceServiceConverted, currency)}
                                    </Typography>
                                </Stack>
                                <Divider
                                    sx={{ marginTop: 2, marginBottom: 2 }}
                                />
                                <Stack
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                >
                                    <Typography
                                        fontSize={18}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={500}
                                        variant={"body2"}
                                    >
                                        Total
                                    </Typography>
                                    <Typography
                                        fontSize={18}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={500}
                                        variant={"body2"}
                                    >
                                        {/* {priceConvertedFinal}{" "}
                                        {currency.toUpperCase()} */}
                                        {formatCurrency(priceConvertedFinal, currency)}
                                    </Typography>
                                </Stack>
                                {(reservation?.roomsBooked && reservation.roomsBooked > 1) && (
                                    <Stack
                                        direction={"row"}
                                        justifyContent={"space-between"}
                                    >
                                        <Typography
                                            fontSize={18}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={500}
                                            variant={"body2"}
                                        >
                                            {t("label.total_for_room_plural", { count: reservation.roomsBooked })}
                                        </Typography>
                                        <Typography
                                            fontSize={18}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={500}
                                            variant={"body2"}
                                        >
                                            {/* {priceConvertedFinal}{" "}
                                            {currency.toUpperCase()} */}
                                            {formatCurrency(
                                                Number(priceConvertedFinal * reservation.roomsBooked),
                                                currency
                                            )}
                                        </Typography>
                                    </Stack>
                                )}
                                {location.pathname.startsWith(
                                "/admin/booking-details"
                            ) && (
                                <>
                                    <Divider
                                        sx={{ marginTop: 2, marginBottom: 2 }}
                                    />
                                    <Stack
                                        direction={"row"}
                                        justifyContent={"space-between"}
                                    >
                                        <Typography
                                            fontSize={18}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={500}
                                            variant={"body2"}
                                            style = {{color: "#890806" }}
                                        >
                                            {t("label.commission-de-la-plateforme")}{" "}
                                        </Typography>
                                        <Typography
                                            fontSize={18}
                                            fontFamily={"Josefin Sans"}
                                            fontWeight={500}
                                            variant={"body2"}
                                            style = {{color: "#890806" }}
                                        >
                                            {formatCurrency(Number(hostCommission * reservation.roomsBooked), currency)}
                                        </Typography>
                                    </Stack>
                                </>
                            )}
                            </Grid>
                        </Grid>
                    </Stack>
                    {/*}
                    {location.pathname.startsWith("/admin/booking-details") && (
                        <>
                            <Divider sx={{ marginTop: 6, marginBottom: 3 }} />
                            <Grid container direction={"row"}>
                                <Grid item xs={12} md={3} lg={3}>
                                    <Typography
                                        fontSize={20}
                                        fontFamily={"Josefin Sans"}
                                        fontWeight={400}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                        }}
                                    >
                                        <History
                                            style={{
                                                marginRight: "10px",
                                                color: "#880608",
                                            }}
                                        />{" "}
                                        {t("reservation.label.change-log")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={9} lg={9}>
                                    {changeLogs.length > 0 ? (
                                        <Stack spacing={2}>
                                            {changeLogs.map((log, index) => (
                                                <Stack key={index} spacing={1} sx={{ 
                                                    p: 2, 
                                                    backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                                                    borderRadius: 1 
                                                }}>
                                                    <Stack direction="row" alignItems="center" spacing={1}>
                                                        <Person fontSize="small" />
                                                        <Typography fontSize={16} fontFamily={"Josefin Sans"} fontWeight={400}>
                                                            {log.changedBy?.firstName} {log.changedBy?.lastName}
                                                        </Typography>
                                                        <Typography fontSize={14} fontFamily={"Josefin Sans"} fontWeight={300}>
                                                            ({log.changedBy?.role})
                                                        </Typography>
                                                        <Typography fontSize={14} fontFamily={"Josefin Sans"} fontWeight={300}>
                                                            {moment(log.timestamp).format("DD/MM/YYYY HH:mm")}
                                                        </Typography>
                                                    </Stack>
                                                    {log.statusChange && (
                                                        <Stack direction="row" alignItems="center" spacing={1}>
                                                            <Update fontSize="small" />
                                                            <Typography fontSize={14} fontFamily={"Josefin Sans"} fontWeight={400}>
                                                                {t("reservation.label.status-changed")}: 
                                                            </Typography>
                                                            <Typography fontSize={14} fontFamily={"Josefin Sans"} fontWeight={300}>
                                                                {getStatusLabel(log.oldStatus)} → {getStatusLabel(log.newStatus)}
                                                            </Typography>
                                                        </Stack>
                                                    )}
                                                    {log.fieldChanges?.length > 0 && (
                                                        <Stack spacing={0.5}>
                                                            {log.fieldChanges.map((change: any, idx: number) => (
                                                                <Stack key={idx} direction="row" alignItems="center" spacing={1}>
                                                                    <Update fontSize="small" />
                                                                    <Typography fontSize={14} fontFamily={"Josefin Sans"} fontWeight={400}>
                                                                        {t(`reservation.label.${change.field}`)}: 
                                                                    </Typography>
                                                                    <Typography fontSize={14} fontFamily={"Josefin Sans"} fontWeight={300}>
                                                                        {change.oldValue?.toString() || t("label.empty")} → {change.newValue?.toString() || t("label.empty")}
                                                                    </Typography>
                                                                </Stack>
                                                            ))}
                                                        </Stack>
                                                    )}
                                                    {log.notes && (
                                                        <Typography fontSize={14} fontFamily={"Josefin Sans"} fontWeight={300} sx={{ fontStyle: 'italic' }}>
                                                            "{log.notes}"
                                                        </Typography>
                                                    )}
                                                </Stack>
                                            ))}
                                        </Stack>
                                    ) : (
                                        <Typography fontSize={16} fontFamily={"Josefin Sans"} fontWeight={300}>
                                            {t("reservation.label.no-changes-found")}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </>
                    )} */}
                </Stack>
            )} 
            <Dialog
                open={openNoShowDialog}
                onClose={handleCloseNoShowDialog}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>{t("no_show.confirm_title")}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {t("no_show.confirm_message")}
                    </DialogContentText>
                    
                    <TextField
                        autoFocus
                        margin="dense"
                        id="noShowNotes"
                        label={t("no_show.notes_label")}
                        type="text"
                        fullWidth
                        variant="standard"
                        multiline
                        rows={3}
                        value={noShowNotes}
                        onChange={(e) => setNoShowNotes(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseNoShowDialog}>{t("common.cancel")}</Button>
                    <Button 
                        onClick={() => {
                            handleMarkNoShow();
                            handleCloseNoShowDialog();
                        }} 
                        color="error"
                    >
                        {t("no_show.confirm_button")}
                    </Button>
                </DialogActions>
            </Dialog>
            <LoginDialog
                open={openLoginDialog}
                handleClose={handleCloseLoginDialog}
                onLoginSuccess={handleLoginSuccess}
                redirectPath={redirectPath}
                handleClickOpenRegister={handleClickOpenRegister} // Add this
            />
            
            {/* Add RegisterDialog if needed */}
            <RegisterDialog
                open={openRegisterDialog}
                handleClose={() => setOpenRegisterDialog(false)}
                handleOpenLoginDialog={() => {
                    setOpenRegisterDialog(false);
                    setOpenLoginDialog(true);
                }}
                redirectPath={redirectPath}
            />
        </>
    );
};

const style = makeStyles(() =>
    createStyles({
        loading: {
            width: "100%",
            minHeight: "40vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    })
);
